import React from 'react';
import './Card.css';

/**
 * Card Component
 * @param {boolean} glass - Enable glassmorphism effect
 * @param {boolean} hover - Enable hover lift effect
 * @param {boolean} noPadding - Remove default padding
 */
const Card = ({
    children,
    className = '',
    glass = false,
    hover = false,
    noPadding = false,
    ...props
}) => {
    const glassClass = glass ? 'ui-card-glass' : 'ui-card-solid';
    const hoverClass = hover ? 'ui-card-hover' : '';
    const paddingClass = noPadding ? 'ui-card-no-padding' : '';

    return (
        <div
            className={`ui-card ${glassClass} ${hoverClass} ${paddingClass} ${className}`}
            {...props}
        >
            {children}
        </div>
    );
};

export const CardHeader = ({ children, className = '', ...props }) => (
    <div className={`ui-card-header ${className}`} {...props}>
        {children}
    </div>
);

export const CardBody = ({ children, className = '', ...props }) => (
    <div className={`ui-card-body ${className}`} {...props}>
        {children}
    </div>
);

export const CardFooter = ({ children, className = '', ...props }) => (
    <div className={`ui-card-footer ${className}`} {...props}>
        {children}
    </div>
);

export default Card;
